// 智慧监控
import Log from "../view/log";
import VideoServiceNav from "../view/VideoServices/VideoServiceNav";
import VideoDevice from "../view/VideoServices/VideoDevice/VideoDevice";
import VideoDeviceAdd from "../view/VideoServices/VideoDevice/VideoDeviceAdd";
import VideoDeviceModify from "../view/VideoServices/VideoDevice/VideoDeviceModify";
import VideoDeviceState from "../view/VideoServices/VideoDeviceState/VideoDeviceState";
import VideoPage from "../view/VideoServices/VideoPage/VideoPage";

export default [
  /* 智慧监控 */
  {
    path: "/video_device",
    name: "video-device",
    components: {
      default: VideoServiceNav,
      a: VideoDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/video_device_add",
    name: "video-device-add",
    components: {
      default: VideoServiceNav,
      a: VideoDeviceAdd
    }
  },
  {
    path: "/video_device_modify/:id",
    name: "video-device-modify",
    components: {
      default: VideoServiceNav,
      a: VideoDeviceModify
    }
  },
  {
    path: "/video_device_state",
    name: "video-device-state",
    components: {
      default: VideoServiceNav,
      a: VideoDeviceState
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/video_page",
    name: "video-page",
    components: {
      default: VideoServiceNav,
      a: VideoPage
    }
  },
  /* 智慧监控 */
  // 智慧监控操作日志
  {
    path: "/video_services_log",
    name: "video-services-log",
    components: {
      default: VideoServiceNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/VideoServices.js